namespace GeniuzPOS.Purchase {
    export interface PoPurRequestDtRow {
        Id?: number;
        SysDocNo?: string;
        WhsId?: string;
        SupplierId?: string;
        ShopId?: string;
        LineItemNo?: number;
        SkuCode?: string;
        SkuDesc?: string;
        UnitCost?: number;
        UnitChange?: UnitChangeEnumFg;
        PurUnit?: string;
        PurUnitRatio?: number;
        PurUnitPrice?: number;
        LastPurUnitPrice?: number;
        Qty?: number;
        BeforeDiscAmt?: number;
        DiscText?: string;
        DiscAmt?: number;
        ItemAmt?: number;
        SalesVatTypes?: string;
        VatType?: string;
        VatCode?: string;
        VatRate?: number;
        ItemVatAmt?: number;
        ItemExVatAmt?: number;
        AlocalteDiscAmt?: number;
        ItemNetAmt?: number;
        ExpDate?: string;
        Remark?: string;
        StkQty?: number;
        QtyUse?: number;
        UseFg?: number;
        PoRefDocNo?: string;
        ItemNetCostValue?: number;
    }

    export namespace PoPurRequestDtRow {
        export const idProperty = 'Id';
        export const nameProperty = 'SkuCode';
        export const localTextPrefix = 'Purchase.PoPurRequestDt';
        export const lookupKey = 'Purchase.PoPurRequestDt';

        export function getLookup(): Q.Lookup<PoPurRequestDtRow> {
            return Q.getLookup<PoPurRequestDtRow>('Purchase.PoPurRequestDt');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            Id = "Id",
            SysDocNo = "SysDocNo",
            WhsId = "WhsId",
            SupplierId = "SupplierId",
            ShopId = "ShopId",
            LineItemNo = "LineItemNo",
            SkuCode = "SkuCode",
            SkuDesc = "SkuDesc",
            UnitCost = "UnitCost",
            UnitChange = "UnitChange",
            PurUnit = "PurUnit",
            PurUnitRatio = "PurUnitRatio",
            PurUnitPrice = "PurUnitPrice",
            LastPurUnitPrice = "LastPurUnitPrice",
            Qty = "Qty",
            BeforeDiscAmt = "BeforeDiscAmt",
            DiscText = "DiscText",
            DiscAmt = "DiscAmt",
            ItemAmt = "ItemAmt",
            SalesVatTypes = "SalesVatTypes",
            VatType = "VatType",
            VatCode = "VatCode",
            VatRate = "VatRate",
            ItemVatAmt = "ItemVatAmt",
            ItemExVatAmt = "ItemExVatAmt",
            AlocalteDiscAmt = "AlocalteDiscAmt",
            ItemNetAmt = "ItemNetAmt",
            ExpDate = "ExpDate",
            Remark = "Remark",
            StkQty = "StkQty",
            QtyUse = "QtyUse",
            UseFg = "UseFg",
            PoRefDocNo = "PoRefDocNo",
            ItemNetCostValue = "ItemNetCostValue"
        }
    }
}
